// Authenticator attachment decoder(ish)!
// Note: we'd preferably use something like `zod` here, but may not worth a dependency
export function decodeAuthenticatorAttachment(data) {
    if ("platform" === data["authenticatorAttachment"]) {
        return "platform";
    }
    if ("cross-platform" === data.authenticatorAttachment) {
        return "cross-platform";
    }
    throw new Error("Invalid authenticatorAttachment value");
}
